import React from 'react';
import {LogoSize, ResourceTabs} from 'app/types/Shared';
import smallLogo from 'assets/images/header/elevateLogoSmall.svg';
import takedaLogo from 'assets/images/header/takedaLogo.svg';

/////React Router Dom/////
import {NavLink, useNavigate, useSearchParams} from 'react-router-dom';
///Local Components//////
import PageLayout from 'components/PageLayout/PageLayout';
import TopNavigation from 'components/TopNavigation/TopNavigation';
import SearchUI from 'components/Search/SearchUI';
import ChangeRole from 'components/ChangeRole/ChangeRole';
import {Breadcrumbs, Link, Grid, Typography} from '@mui/material';
import {useMatomo} from '@jonkoops/matomo-tracker-react';
import {useSelector} from 'react-redux';
import {selectOnboarding} from 'app/store/appState/appStateSlice';

const SearchPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q');
  const tabParam = searchParams.get('tab') ?? null;
  const tabIndex = tabParam ? parseInt(tabParam) : 0;
  // Matomo Analytics
  const {trackPageView} = useMatomo();
  React.useEffect(() => {
    trackPageView();
  });
  const onboarding = useSelector(selectOnboarding);

  const onHome = () => {
    navigate(`/`);
    return Promise.resolve();
  };

  const onLogout = async () => {
    navigate('/logout');
    return Promise.resolve();
  };

  const toResources = async () => {
    navigate('/resources');
    return Promise.resolve();
  };

  const toArtifactsPage = async () => {
    navigate('/resources/process-documents');
    return Promise.resolve();
  };

  //esnsure no tab index is outside of params
  const sanatizeTabIndex = (index: number) => {
    if (index < 0) return 0;
    const length = Object.values(ResourceTabs).length;
    if (index < length) return index;
    else return 0;
  };

  //start at top of page
  const [onFirstLoad, setFirstLoad] = React.useState(true);
  React.useEffect(() => {
    if (onFirstLoad) {
      window.scrollTo(0, 0);
      setFirstLoad(false);
    }
  }, [onFirstLoad]);

  const header = (
    <TopNavigation
      authorized={true}
      logout={onLogout}
      home={onHome}
      smallLogo={smallLogo}
      rightLogo={takedaLogo}
      LogoType={LogoSize.Small}
      toResources={toResources}
      banner={onboarding?.topBanner}
    />
  );
  const footer = <></>;

  return (
    <PageLayout header={header} footer={footer} globalBannerCallback={onLogout}>
      <Grid
        justifyContent='flex-start'
        alignItems='flex-end'
        container
        direction='row'
        spacing={1}
        px={6}
        marginTop={onboarding?.topBanner ? 7.5 : 2.5}
      >
        <Grid item xs={3}>
          <Breadcrumbs
            sx={{
              '.MuiBreadcrumbs-separator': {
                color: 'primary.main',
              },
            }}
          >
            <Link underline='hover' color='primary.main' component={NavLink} to='/home'>
              Home
            </Link>
            <Typography color='primary.main'>Search</Typography>
          </Breadcrumbs>
        </Grid>
        <Grid item xs={9} minHeight='70px' display='flex' justifyContent='flex-end'>
          <ChangeRole />
        </Grid>
      </Grid>
      <SearchUI
        initialQuery={query ? query : ''}
        initialTabIndex={tabIndex ? sanatizeTabIndex(tabIndex) : 0}
        veiwAllCallback={toArtifactsPage}
      />
    </PageLayout>
  );
};

export default SearchPage;
